import axios from 'axios';

import { connect } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react'

import { getAnalytics, logEvent } from "firebase/analytics";

import PodcastLoadingView from '../components/PodcastLoadingView';
import PodcastView from '../components/PodcastView';
import { buildMissingRoute } from '../utils/missingRoute';


const Podcast = ({

}) => {

    let params = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const analytics = getAnalytics();
    const missingRoute = buildMissingRoute(location);

    const [podcast, setPodcast] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (podcast?.id === params.podcastId) {
            setLoading(false);
            return;
        }
        let cancelled = false;
        document.getElementById('audio').pause();
        if (!!params.podcastId) {
            setLoading(true);
            axios
                .get(`/podcast/${params.podcastId}`)
                .then((res) => {
                    if (cancelled) return;
                    const data = res.data;

                    if (!data || !data.id) {
                        setLoading(false);
                        navigate(missingRoute, { replace: true });
                        return;
                    }

                    if (data.id !== params.podcastId) {
                        navigate(`/podcast/${encodeURIComponent(data.id)}${location.search}${location.hash}`, {
                            replace: true,
                            state: location.state,
                        });
                        return;
                    }

                    setLoading(false);
                    setPodcast(data);
                })
                .catch((err) => {
                    if (cancelled) return;
                    setLoading(false);
                    console.log(err);
                    navigate(missingRoute, { replace: true });
                });
        } else {
            setLoading(false);
            navigate(missingRoute, { replace: true });
        }
        return () => { cancelled = true; };
    }, [missingRoute, navigate, params.podcastId, location.search, location.hash, location.state, podcast?.id]);

    useEffect(() => {
        logEvent(analytics, 'screen_view', {
            firebase_screen: 'podcast'
        });
    }, [analytics]);

    return (
        <div>
            {loading ?
                <PodcastLoadingView />
                :
                <PodcastView podcast={podcast} />
            }
        </div>
    );
};

const mapStateToProps = (state) => ({
})

const mapActionsToProps = {
}

export default connect(mapStateToProps, mapActionsToProps)(Podcast);
